const Loading = () => {
    return (
        <section className="loading">
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only"></span>
            </div>
        </section>
    );
}

export default Loading;